module.exports = __webpack_public_path__ + "img/logo.1d6a1e68.svg";